export const ORDERS_LABELS = Object.freeze({
  headers: Object.freeze({
    customer: "Cliente",
    account: "Cuenta",
    phone: "Telefono",
    type: "Tipo",
    folio: "Folio",
    amount: "Monto",
    createdDate: "Fecha creación",
    scheduledDate: "Fecha programada",
    status: "Estatus",
    station: "Planta",
    unit: "Unidad",
    agent: "Agente",
    address: "Domicilio",
    actions: "Acciones",
  }),
  tooltips: Object.freeze({
    activeCoupon: "Cupón activo",
    details: "Detalles",
    issueTicket: "Generar Ticket de Fuga o Queja",
  }),
  modals: Object.freeze({
    createTicket: "Crear ticket",
  }),
});
